import type { RouteRecordRaw } from "vue-router";

import { PickingRoutes, TestPickingRoutes } from "../enums/routes/PickingRoutes";
import BetaPickingLayout from "../layout/app/beta/PickingLayout.vue";
import PickingLayout from "../layout/app/production/PickingLayout.vue";

export function pickingRoutes(): RouteRecordRaw[] {
    return [
        {
            path: "/picking",
            component: PickingLayout,
            children: [
                {
                    path: "/picking",
                    name: PickingRoutes.IDLE,
                    component: () => import("@/views/apps/picking/PickingIdleView.vue"),
                },
                {
                    path: "/picking/signin",
                    name: PickingRoutes.SIGNIN,
                    component: () => import("@/views/apps/picking/PickingSignInView.vue"),
                },
                {
                    path: "/picking/load",
                    name: PickingRoutes.LOAD_CONTAINER,
                    component: () => import("@/views/apps/picking/PickingLoadContainerView.vue"),
                },
                {
                    path: "/picking/settings",
                    name: PickingRoutes.SETTINGS,
                    component: () => import("@/views/apps/picking/PickingUserSettingsView.vue"),
                },
                {
                    path: "/picking/container",
                    name: PickingRoutes.PICKING_CONTAINER,
                    component: () => import("@/views/apps/picking/PickingCartView.vue"),
                },
            ],
        },
        {
            path: "/test/picking",
            component: BetaPickingLayout,
            children: [
                {
                    path: "/test/picking",
                    name: TestPickingRoutes.IDLE,
                    component: () => import("@/views/apps/test/picking/PickingIdleView.vue"),
                },
                {
                    path: "/test/picking/signin",
                    name: TestPickingRoutes.SIGNIN,
                    component: () => import("@/views/apps/test/picking/PickingSignInView.vue"),
                },
                {
                    path: "/test/picking/load",
                    name: TestPickingRoutes.LOAD_CONTAINER,
                    component: () => import("@/views/apps/test/picking/PickingLoadContainerView.vue"),
                },
                {
                    path: "/test/picking/settings",
                    name: TestPickingRoutes.SETTINGS,
                    component: () => import("@/views/apps/test/picking/PickingUserSettingsView.vue"),
                },
                {
                    path: "/test/picking/container",
                    name: TestPickingRoutes.PICKING_CONTAINER,
                    component: () => import("@/views/apps/test/picking/PickingCartView.vue"),
                },
            ],
        },
    ];
}
